import { ChangeDetectionStrategy, Component, output } from '@angular/core';
import { AbstractDynamicComponent } from '@components/abstracts';
import { Galerie } from '@components/galerie/models';
import { ImageComponent } from '@shared/components/image';
import { Image } from '@shared/components/image/models';
import { TitleComponent } from '@shared/components/title';
import { VideoComponent } from '@shared/components/video';

@Component({
  selector: 'app-galerie-4itiv',
  imports: [ImageComponent, TitleComponent, VideoComponent],
  templateUrl: './galerie-4itiv.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Galerie4itivComponent extends AbstractDynamicComponent<Galerie> {
  zoomImageRequested = output<Image>();
}
